import type { CacheOptions } from "@warp-drive/core/types/request";
import { query } from "../builders";
import { invoiceHandler } from "./handlers";
import type { Invoice } from "./schema";

export const invoiceList = (organizationId: string, cacheOptions?: CacheOptions) =>
  query<Invoice>(
    "invoice/list",
    { organizationnumber: organizationId },
    { handler: invoiceHandler(organizationId) },
    { types: ["invoice"], ...cacheOptions },
  );
